<template>
    <v-dialog v-model="value" max-width="500px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Excluir registro
                    <v-icon right>
                        mdi-cash-remove
                    </v-icon>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-alert v-if="error_message" type="error">
                        {{ error_message }}
                    </v-alert>
                    <v-form ref="formRemove">
                        <v-row>
                            <v-col cols="6">
                                <v-switch
                                    v-model="expense"
                                    inset
                                    color="error"
                                    label="Despesa"
                                    disabled
                                ></v-switch>
                            </v-col>
                            <v-col cols="6">
                                <v-switch
                                    v-model="income"
                                    inset
                                    color="success"
                                    label="Receita"
                                    disabled
                                ></v-switch>
                            </v-col>
                            <v-col cols="6">
                                <base-date-picker
                                    v-model="extract.date"
                                    label="Data do registro"
                                    disabled
                                ></base-date-picker>
                            </v-col>
                            <v-col cols="6">
                                <base-text-money
                                    v-model="extract.price"
                                    label="Valor"
                                    disabled
                                ></base-text-money>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-model="extract.category"
                                    label="Categoria"
                                    :items="macro_category"
                                    disabled
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-model="extract.account"
                                    label="Conta / Voucher"
                                    :items="accounts"
                                    disabled
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="extract.description"
                                    label="Descrição"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="extract.long_description"
                                    label="Descrição"
                                    disabled
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    :disabled="loading"
                    @click="close"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="error"
                    text
                    :disabled="loading"
                    @click="remove"
                >
                    Excluir
                </v-btn>
            </v-card-actions>
            <v-progress-linear
                v-if="loading"
                indeterminate
                height="6"
            ></v-progress-linear>
        </v-card>
        <base-notify
            v-model="show_notify"
            :type="notify_type"
            :message="notify_message"
        >
        </base-notify>
    </v-dialog>
</template>

<script>
import BaseNotify from "../../../components/BaseNotify.vue";
import BaseTextMoney from "../../../components/BaseTextMoney";
import BaseDatePicker from "../../../components/BaseDatePicker";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        BaseNotify,
        BaseTextMoney,
        BaseDatePicker
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        extractId: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            error_message: null,
            show_notify: false,
            notify_type: null,
            notify_message: "",
            macro_category: [],
            accounts: [],
            expense: null,
            income: null,
            extract: {
                date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                price: null,
                category: null,
                account: null,
                description: null,
                long_description: null,
                type: "E"
            }
        };
    },
    computed: {
        ...mapState("account", {
            list_accounts: state => state.accounts
        }),
        ...mapState("settings", {
            list_macro_category: state => state.macro_category
        })
    },
    watch: {
        income(new_value) {
            this.expense = !new_value;
        },
        expense(new_value) {
            this.income = !new_value;
        },
        value(new_value) {
            if (new_value) {
                this.read();
            }
        }
    },
    mounted() {
        if (!this.list_macro_category || this.list_macro_category.length === 0) {
            this.getListMacroCategory();
        } else {
            this.makeListMacroCategory();
        }

        if (!this.list_accounts || this.list_accounts.length === 0) {
            this.getListAccount();
        } else {
            this.makeListAccounts();
        }
    },
    methods: {
        ...mapActions("settings", ["ActionDoListMacroCategory"]),
        ...mapActions("account", ["ActionDoListAccounts"]),
        ...mapActions("extract", ["ActionDoDeleteExtract", "ActionDoReadExtract"]),
        close() {
            this.cleanForm();
            this.$emit("close");
            this.$emit("input", false);
        },
        cleanForm() {
            this.extract = {
                date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                price: null,
                category: null,
                account: null,
                description: null,
                long_description: null,
                type: "E"
            };

            this.expense = true;

            this.$refs.formRemove.resetValidation();
        },
        async read() {
            this.loading = true;

            if (this.extractId) {
                await this.ActionDoReadExtract(this.extractId).then(response => {
                    this.extract = {
                        date: (new Date(response.date)).toISOString().substr(0, 10),
                        price: response.value,
                        category: response.category_id,
                        account: response.account_id,
                        description: response.description,
                        long_description: response.long_description,
                        type: response.type
                    };

                    this.expense = response.type === "E" ? true : false;

                    this.loading = false;
                });
            } else {
                this.close();
            }
        },
        remove() {
            this.loading = true;

            if (this.$refs.formRemove.validate()) {
                try {
                    this.ActionDoDeleteExtract(this.extractId).then(response => {
                        this.error_mesasge = null;

                        if (response.extract) {
                            this.show_notify = true;
                            this.notify_type = "success";
                            this.notify_message = "Registro excluido com sucesso!";
                            this.loading = false;
                            this.close();
                        } else {
                            this.show_notify = true;
                            this.notify_type = "error";
                            this.notify_message = "Ocorreu um erro!";
                            this.loading = false;
                            this.error_mesasge = response.error;
                        }
                    });
                } catch (error) {
                    this.show_notify = true;
                    this.notify_type = "error";
                    this.notify_message = "Ocorreu um erro!";
                    this.loading = false;
                    this.error_mesasge = error.response.data.error;
                }
            } else {
                this.loading = false;
            }
        },
        async getListMacroCategory() {
            await this.ActionDoListMacroCategory().then(() => {
                this.makeListMacroCategory();
            });
        },
        makeListMacroCategory() {
            for (let macro of this.list_macro_category) {
                this.macro_category.push({
                    text: macro.name,
                    value: macro.id + "macro",
                    header: macro.name
                });

                for (let category of macro.categories) {
                    this.macro_category.push({
                        text: category.name,
                        value: category.id,
                        divider: false
                    });
                }
            }
        },
        async getListAccount() {
            await this.ActionDoListAccounts().then(() => {
                this.makeListAccounts();
            });
        },
        makeListAccounts() {
            let bank = [];
            let voucher = [];

            for (let account of this.list_accounts) {
                if (account.account_type === "B") {
                    bank.push({
                        text: account.name,
                        value: account.id,
                        divider: false
                    });
                } else {
                    voucher.push({
                        text: account.name,
                        value: account.id,
                        divider: false
                    });
                }
            }

            this.accounts.push({
                text: "Conta bancária",
                value: "B",
                header: "Conta bancária"
            });

            for (let bank_account of bank) {
                this.accounts.push(bank_account);
            }

            this.accounts.push({
                text: "Voucher",
                value: "V",
                header: "Voucher"
            });

            for (let voucher_account of voucher) {
                this.accounts.push(voucher_account);
            }
        }
    }
};
</script>
